import React from 'react';

import type { SimpleIconInterface } from './icon-utils';
import { SimpleIcon } from './icon-utils';

export function CheckMarkIcon({
  className,
  fill,
  height,
  width,
}: SimpleIconInterface): JSX.Element {
  return (
    <SimpleIcon
      className={className}
      height={height ?? 12}
      viewBoxDimensions="0 0 12 12"
      width={width ?? 12}
    >
      <path
        d="M10.073.882a.75.75 0 0 1 1.229.86l-6.287 8.981a1.667 1.667 0 0 1-2.703.047l-1.6-2.133a.75.75 0 0 1 1.2-.9l1.601 2.134a.167.167 0 0 0 .272-.006L10.073.882z"
        fill={fill ?? '#3942B7'}
        fillRule="nonzero"
      />
    </SimpleIcon>
  );
}
